import { useEffect, useState } from "react";
import { AiFillFileText } from "react-icons/ai";
import {
  FaAngleLeft,
  FaAngleRight,
  FaBook,
  FaClipboardList,
  FaDatabase,
  FaDyalog,
  FaFileInvoiceDollar,
  FaHome,
  FaSignOutAlt,
  FaUsers,
  FaUserTie,
} from "react-icons/fa";
import { MdEventAvailable, MdOutlineMessage } from "react-icons/md";
import { IoAnalyticsOutline } from "react-icons/io5";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  {
    label: "Dashboard",
    icon: <FaHome size={16} />,
    path: "/rankers/dashboard",
  },
  {
    label: "Users",
    icon: <FaDatabase size={16} />,
    path: "/rankers/users",
  },
  
  {
    label: "Test Series",
    icon: <FaBook size={16} />,
    path: "/rankers/test-series",
  },
  {
    label: "Subjects",
    icon: <FaFileInvoiceDollar size={16} />,  
    path: "/rankers/subjects",
  },
  {
    label: "Topics",
    icon: <FaBook size={16} />,
    path: "/rankers/topics",
  },
  {
    label: "Questions",
    icon: <FaBook size={16} />,
    path: "/rankers/questions",
  },
  {
    label: "Previous Year Questions",
    icon: <FaBook size={16} />,
    path: "/rankers/pyq",
  },
  {
    label: "Excel Sheet Upload",
    icon: <FaBook size={16} />,
    path: "/rankers/excel-sheet-upload",
  },
  {
    label: "User Tracking",
    icon: <IoAnalyticsOutline size={16} />,
    path: "/rankers/user-tracking",
  },
];

const CustomSidebar = ({ menuCollapse, setMenuCollapse }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.state?.openDropdown && //ye check karta hai ki navigat ke time kuch state pass hui hai kya
      openDropdown !== location.state.openDropdown //check karta hai ki pahle se dropdown open hai ya nhi agar hai toh dobara update karne ki jarurat nhi hai
    ) {
      setOpenDropdown(location.state.openDropdown); // component dropdown update here hum jis bhi component par click karenge wo update ho jayega
      navigate(location.pathname, { replace: true });
    }
  }, [location.state, location.pathname, navigate, openDropdown]);

  const toggleDropdown = (label) => {
    setOpenDropdown(openDropdown === label ? null : label);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div
      style={{
        width: menuCollapse ? "60px" : "200px",
        height: "100vh",
        backgroundColor: "#f9fafb",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        transition: "width 0.5s ease-in-out",
      }}
    >
      <div>
        <button
          onClick={() => setMenuCollapse(!menuCollapse)}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: menuCollapse ? "center" : "flex-end",
            width: "100%",
            padding: "10px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            marginBottom: "10px",
            backgroundColor: "#f9fafb",
          }}
        >
          <span
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: menuCollapse ? "center" : "flex-start",
              fontSize: "20px",
              fontWeight: "600",
              textDecorationLine: "underline",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {menuCollapse ? "" : "Rankers"}
          </span>
          {menuCollapse ? <FaAngleRight /> : <FaAngleLeft />}
        </button>

        {navItems.map((item) => {
          if (item.path) {
            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setOpenDropdown(null)}
                style={({ isActive }) => ({
                  display: "flex",
                  alignItems: "center",
                  padding: "10px 15px",
                  color: "black",
                  backgroundColor: "#f3f4f6",
                  fontWeight: isActive ? "bold" : "normal",
                  textDecoration: "none",
                  borderRadius: "4px",
                  marginBottom: "5px",
                })}
                title={menuCollapse ? item.label : ""}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: menuCollapse ? "center" : "flex-start",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <span style={{ fontSize: "20px" }}>{item.icon}</span>
                  {!menuCollapse && <span>{item.label}</span>}
                </span>
              </NavLink>
            );
          }

          const isOpen = openDropdown === item.label;

          return (
            <div key={item.label}>
              <button
                onClick={() => toggleDropdown(item.label)}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  padding: "10px 15px",
                  backgroundColor: "#f3f4f6",
                  border: "none",
                  cursor: "pointer",
                  color: "black",
                  fontWeight: "600",
                }}
                title={menuCollapse ? item.label : ""}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {item.icon}
                  {!menuCollapse && item.label}
                </span>
                {!menuCollapse && (
                  <span
                    style={{
                      transform: isOpen ? "rotate(180deg)" : "none",
                      transition: "0.2s",
                    }}
                  >
                    ▼
                  </span>
                )}
              </button>

              {isOpen &&
                !menuCollapse &&
                item.children.map((child) => (
                  <NavLink
                    key={child.path}
                    to={child.path}
                    style={({ isActive }) => ({
                      display: "flex",
                      alignItems: "center",
                      padding: "8px 15px",
                      color: "black",
                      backgroundColor: isActive ? "#3b82f6" : "transparent",
                      fontWeight: isActive ? "bold" : "normal",
                      textDecoration: "none",
                      borderRadius: "4px",
                      marginBottom: "5px",
                      overflow: "hidden",
                      marginLeft: "10px",
                    })}
                    title={child.label}
                  >
                    {child.icon}
                    <span
                      style={{
                        marginLeft: "10px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        flex: 1,
                      }}
                    >
                      {child.label}
                    </span>
                  </NavLink>
                ))}
            </div>
          );
        })}
      </div>

      <div>
        <NavLink
          to="/dashboard" // ✅ ye missing tha
          style={({ isActive }) => ({
            display: "flex",
            alignItems: "center",
            padding: "8px 10px",
            color: "black",
            backgroundColor: isActive ? "#3b82f6" : "#f3f4f6",
            fontWeight: isActive ? "bold" : "normal",
            textDecoration: "none",
            borderRadius: "4px",
            marginBottom: "5px",
            cursor: "pointer",
          })}
          title="DevQsoft"
        >
          <FaDyalog />
          {!menuCollapse && <span style={{ marginLeft: "10px" }}>DevQsoft</span>}
        </NavLink>
        <button
          onClick={handleLogout}
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 10px",
            color: "black",
            fontWeight: "bold",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            backgroundColor: "#fee2e2",
            width: "100%",
          }}
          title="Logout"
        >
          <FaSignOutAlt />
          {!menuCollapse && <span style={{ marginLeft: "10px" }}>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default CustomSidebar;
